/**
 * Utilitaire pour le tracking Google Analytics
 * Centralise tous les événements trackés sur le site
 */

/**
 * Track un événement dans Google Analytics
 * @param {string} action - L'action effectuée (ex: 'form_submit', 'phone_click')
 * @param {string} category - Catégorie de l'événement (ex: 'Contact', 'Navigation')
 * @param {string} label - Label descriptif (ex: 'Form Submitted', 'Phone Number')
 * @param {number} value - Valeur optionnelle (ex: montant, quantité)
 */
export const trackEvent = (action, category, label, value = undefined) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

/**
 * Track la soumission du formulaire de contact
 * @param {string} subject - Sujet du formulaire (reservation, info, question)
 */
export const trackFormSubmit = (subject) => {
  trackEvent("form_submit", "Contact", `Form Submitted - ${subject}`, 1);
};

/**
 * Track un clic sur le numéro de téléphone
 * @param {string} location - Où le clic a eu lieu (header, contact, studio, etc.)
 */
export const trackPhoneClick = (location) => {
  trackEvent("phone_click", "Contact", `Phone Click - ${location}`);
};

/**
 * Track un clic vers Airbnb
 * @param {string} property - Propriété concernée (studio516, appartement407)
 */
export const trackAirbnbClick = (property) => {
  trackEvent("external_link", "Airbnb", `Airbnb Click - ${property}`);
};

/**
 * Track l'ouverture d'une image dans la lightbox
 * @param {string} imageAlt - Description de l'image
 * @param {string} property - Propriété concernée
 */
export const trackImageView = (imageAlt, property) => {
  trackEvent("image_view", "Gallery", `${property} - ${imageAlt}`);
};

/**
 * Track un clic sur un email
 * @param {string} location - Où le clic a eu lieu
 */
export const trackEmailClick = (location) => {
  trackEvent("email_click", "Contact", `Email Click - ${location}`);
};

/**
 * Track la vue d'une page (automatique avec React Router)
 * @param {string} path - Chemin de la page
 * @param {string} title - Titre de la page
 */
export const trackPageView = (path, title) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("config", "G-G4F70GH5EP", {
      page_path: path,
      page_title: title,
    });
  }
};

/**
 * Track un clic sur un lien de navigation
 * @param {string} destination - Page de destination
 * @param {string} label - Label descriptif du lien
 */
export const trackNavigation = (destination, label) => {
  trackEvent("navigation_click", "Navigation", label || destination);
};
